import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';


const HealowCheckIn = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateAndScroll = (pathname, sectionId) => {
    if (location.pathname !== pathname) {
      navigate(pathname);
    }

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); // Adjust the timeout as needed to ensure the page has navigated
  };

  return (
    
    <div className="w-full py-8 ">
      <div className="flex justify-center smartphone:hidden items-center relative">
        <div className="relative w-auto z-1 mt-[-140px]">
          <img
            className="w-full h-auto shadow-lg mt-2"
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Healow+check+in+overlay_crop.webp"
            alt="Children sitting with hands closed"
          />
        </div>
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 smartphone:hidden">
            <button className="text-white font-bold bg-custom-regularOrange px-2 py-1 rounded-md hover:bg-custom-darkOrange"
            onClick={() => handleNavigateAndScroll('/patient-center', 'newPatient')}>
              New to our practice - LET US HELP YOU
            </button>
          </div>
      </div>
      <h2 className="text-4xl font-bold text-gray-800 m-4 mx-auto max-w-4xl">Patient Check-Ins with Healow CHECK-IN™</h2>
      <hr className="border-t-2 border-blue-500 mb-6 mx-auto max-w-4xl" />

      <div className="space-y-6 m-4 mx-auto max-w-4xl">
        <p className="text-gray-600">
          With <span className="font-semibold">Healow CHECK-IN™</span>, we’ve revolutionized the pre-visit process
          to make it more convenient, efficient, seamless, and paperless. This healthcare IT solution enables you
          to check in for your appointments from the comfort of your home—via smartphone or computer—before
          even stepping into our office. It helps in reducing wait times, enhancing accuracy, and streamlining the
          overall check-in process.
        </p>

        <h3 className="text-2xl font-bold text-gray-800 mb-2">How It Works</h3>
        <ul className="list-disc list-outside ml-5 text-gray-600 space-y-2">
          <li>
            <span className="font-semibold">Automated Appointment Reminders:</span> The day before a patient’s
            appointment, healow CHECK-IN automatically sends a secure text reminder and an email to your phone
            and the <span className="font-semibold">healow®</span> app. By simply clicking on the reminder, you can
            confirm your appointment and begin the check-in process.
          </li>
          <li>
            <span className="font-semibold">Comprehensive Patient Check-In:</span> During the check-in process, you
            can review and update your demographics, confirm insurance details, sign consent forms, complete
            necessary questionnaires, and verify medications, allergies, hospitalizations, and surgical histories.
          </li>
          <li>
            <span className="font-semibold">Secure Payment Processing:</span> Through healow Payment Services, you
            can conveniently pay copayments or settle outstanding balances ahead of your visit.
          </li>
          <li>
            <span className="font-semibold">Arrival Notification:</span> Upon arriving at our office, you can simply
            click <span className="italic">"I have arrived"</span> in the app, notifying our staff of your presence and
            providing location details to ensure a smooth transition to your appointment.
          </li>
          <li>
            <span className="font-semibold">Healow CHECK-IN™ QR Code:</span> You can also start the check-in
            process by scanning the QR code on your mobile phone.
          </li>
          <li>
            <span className="font-semibold">Privacy and Security:</span> This secure platform adheres to HIPAA
            regulations for patient data protection.
          </li>
        </ul>

        <p className="text-gray-600">
          <a
            href="https://healow.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            Click here
          </a>{' '}
          to download the healow® app for iOS or Android and follow the simple setup instructions.
        </p>

        <h3 className="text-2xl font-bold text-gray-800 mb-2">Watch the healow CHECK-IN™ Process</h3>
        <iframe
        className="w-full smartphone:h-64 tablet:h-80 laptop:h-[500px] rounded-md shadow-lg"
        src="https://www.youtube.com/embed/vv9IBZA9Rmo?si=fn5jF4YecnTIc2Y5"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      </div>
    </div>
  );
};

export default HealowCheckIn;
